import { useMemo } from "react";
import { useBinanceSpotEthBtcQuote } from "@/hooks/api/useBinanceSpotEthBtcQuote";

/** 顶栏：`useBinanceSpotEthBtcQuote`（5s）；TSK 固定展示。 */
export interface CoinPrice {
  symbol: string;
  price: number;
  change24h: number;
  prevPrice: number;
}

const TSK_BASE = 0.005;

const TSK_FIXED: CoinPrice = {
  symbol: "TSK",
  price: TSK_BASE,
  change24h: 0,
  prevPrice: TSK_BASE,
};

function pairToSymbol(pair: string): "BTC" | "ETH" | null {
  const p = pair.trim().replace(/-/g, "").toUpperCase();
  if (p === "BTCUSDT") return "BTC";
  if (p === "ETHUSDT") return "ETH";
  return null;
}

const ZERO_BTC: CoinPrice = {
  symbol: "BTC",
  price: 0,
  change24h: 0,
  prevPrice: 0,
};
const ZERO_ETH: CoinPrice = {
  symbol: "ETH",
  price: 0,
  change24h: 0,
  prevPrice: 0,
};

export function useCryptoPrices(): CoinPrice[] {
  const { data } = useBinanceSpotEthBtcQuote();

  const [btc, eth] = useMemo(() => {
    const items = data?.items;
    if (!items?.length) {
      return [ZERO_BTC, ZERO_ETH] as const;
    }

    let nextBtc = { ...ZERO_BTC };
    let nextEth = { ...ZERO_ETH };

    for (const row of items) {
      const sym = pairToSymbol(row.pair);
      if (!sym) continue;

      const price = parseFloat(row.lastPrice);
      const change24h = parseFloat(row.priceChangePercent24h);
      if (isNaN(price)) continue;

      if (sym === "BTC") {
        nextBtc = {
          symbol: "BTC",
          price,
          change24h: isNaN(change24h) ? 0 : change24h,
          prevPrice: price,
        };
      } else if (sym === "ETH") {
        nextEth = {
          symbol: "ETH",
          price,
          change24h: isNaN(change24h) ? 0 : change24h,
          prevPrice: price,
        };
      }
    }

    return [nextBtc, nextEth] as const;
  }, [data]);

  return [TSK_FIXED, btc, eth];
}
